import React from 'react';
import TitleSummaryList from './TitleSummary';
import SummaryList from './SummaryList';
import { formatCurrency } from '../../utils/currency.utils';
import { HotelCard } from '../resultCards';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import moment from 'moment';

const HotelSummaryList = ({ response, onSelect, currency, currencyCulture }) => {
  const { t } = useTranslation(i18nNS.tripSummary);
  const { tKey } = useComponentTKey('HotelSummaryList');
  let nights = 0;

  if (response.CheckOutDate && response.CheckInDate) {
    nights = moment(response.CheckOutDate).diff(moment(response.CheckInDate), 'days');
  }

  return (
    <>
      <TitleSummaryList
        desc={
          response.NoOfRooms +
          ' ' +
          (Number(response.NoOfRooms) === 1 ? t(tKey('Room')) : t(tKey('Rooms'))) +
          (nights
            ? ', ' + nights + ' ' + (nights === 1 ? t(tKey('Night')) : t(tKey('Nights')))
            : '')
        }
        amount={formatCurrency(response.BaseRateTotalDays, currency, currencyCulture)}
        iconName="hotel"
      />
      <SummaryList>
        <HotelCard
          item={response}
          disableDetails
          hidePrice
          onPress={onSelect}
          subtitle={response.CityName}
          currency={currency}
          currencyCulture={currencyCulture}
        />
      </SummaryList>
    </>
  );
};

export default HotelSummaryList;
